import { Component, Input, OnChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ClientPresenceService, ClientPresenceState } from '@app/core/services/client-presence.service';
import { Client } from '@app/core/types/client';

// The client's full name with their live website status underneath (онлайн / офлайн / няма данни).
@Component({
  selector: 'itfg-client-name',
  templateUrl: './client-name.component.html',
  styleUrl: './client-name.component.scss',
  standalone: false,
})
export class ClientNameComponent implements OnChanges {
  @Input() client: Client;

  state$: Observable<ClientPresenceState> = of('unknown');

  constructor(private presence: ClientPresenceService) {}

  ngOnChanges() {
    this.state$ = this.presence.state$(this.client);
  }
}
